module.exports = __webpack_public_path__ + "static/img/pic_tupianyasuo_132＊132@2x.8f90997d.png";